import { UploadedAttachment } from 'aos-services/src/services/attachments/types/UploadedAttachment'
import { CarouselIndicator } from 'aos-ui-universal'
import React, { FCWithChildren } from 'react'
import styled from 'styled-components'

import { Box } from '../base/Box'
import { ClickOutside } from '../base/ClickOutside'
import { PreviewItem } from './PreviewItem'

export interface PreviewViewBoxProps {
    attachment: UploadedAttachment
    count: number
    activeIndex: number
    onPrev(): void
    onNext(): void
    onDotPress(index: number): void
    close(): void
}

export const PreviewViewBox: FCWithChildren<PreviewViewBoxProps> = props => (
    <Wrapper centered>
        <PreviewItem attachment={props.attachment} />
        <BottomControls onClickOutside={props.close}>
            {props.count > 1 && (
                <CarouselIndicator
                    count={props.count}
                    activeIndex={props.activeIndex}
                    onPrev={props.onPrev}
                    onNext={props.onNext}
                    onDotPress={props.onDotPress}
                />
            )}
        </BottomControls>
    </Wrapper>
)

const Wrapper = styled(Box)`
    width: 100vw;
    height: 100vh;
    padding: 10vh 10vw;
`

export const BottomControls = styled(ClickOutside)`
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    position: fixed;
    bottom: 25px;
    left: 50%;
    transform: translateX(-50%);
    pointer-events: all;
`
